export default __webpack_public_path__ + "static/media/banner1en.fa2cc270.png";